import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SemaforoService {
  private readonly apiURL = environment.api_proyecciones;
  private headers = new HttpHeaders().append('Content-Type', 'application/json');
  constructor(
    private http: HttpClient,
  ) { }

  public postSemaforo(indId: number, tmpId:number, semaforo):Observable<any>{
    const sem = {
      indicadorid: indId,
      templateid: tmpId, 
      nombre: '',
      limiteinferior: semaforo.limiteinferior,
      limitesuperior: semaforo.limitesuperior,
      condiciones: semaforo.condiciones,
    }
    const body = JSON.stringify(sem);
    const apiURL = this.apiURL + 'api/semaforo/create';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  public patchSemaforo(semId: number, tmpId:number, semaforo):Observable<any>{
    const sem = {
      semaforoid: semId,
      templateid: tmpId,
      nombre: '',
      limiteinferior: semaforo.limiteinferior,
      limitesuperior: semaforo.limitesuperior,
      condiciones: semaforo.condiciones,
    }
    const body = JSON.stringify(sem);
    const apiURL = this.apiURL + 'api/semaforo/update';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  public deleteSemaforo(semId:number):Observable <any>{
    const sem = {
      semaforoid: semId,
    }
    const body = JSON.stringify(sem);
    const apiURL = this.apiURL + 'api/semaforo/delete';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
  public getSemaforos(indId: number, tmpId:number):Observable <any>{
     const sem = {
      // indicadorid: indId,
      templateid: tmpId,
    }
    const body = JSON.stringify(sem);
    const apiURL = this.apiURL + 'api/semaforo/listar';
    return this.http.post(apiURL, body, { headers: this.headers});
  }
}
